<template>
  <main class="main page-inside text-page">
    <div class="section hero-section" v-if="text">
      <div v-if="text.title" class="title">
        <b>{{ $t(text.title) }}</b>
      </div>
    </div>
    <div class="section text-section">
      <div class="page-inside-top">
        <Transition>
          <div class="wrapper" v-if="text">
            <div 
              v-if="text.header"
              class="desc" 
              v-html="$t(text.header)"
            />
            <div 
               v-if="text.content"
              class="desc"  
              v-html="$t(text.content)"
            />
          </div>
        </Transition>
      </div>
    </div>
  </main>
</template>
<script>
import{getStaticStore} from '../stores/static'

export default {
  name: 'TextPage',
  props: {
    slug: String,
    id: String
  },
  components: {

  },
  data: function() {
    return {
      staticStore: ''
    }
  },
  computed: {
    text() {
      return this.staticStore.textPageData;
    }
  },
  mounted() {
    this.staticStore = getStaticStore();
    const identifier = this.slug || this.id || this.$route.params.id || this.$route.params.slug;
    this.staticStore.getTextPageContent(identifier);
  },
  methods: {
    
  }
}
</script>